import { Routes, Route } from 'react-router-dom';
import { permissoesRotas } from '../util/rotas_roles_permitidas';

import Home from './Home';
import Graficos from './Graficos';
import PrivateRoute from './RotasPrivadas';
import TelaInformativa from './TelaInformativa';
import CriaFormularioAcompanhamento from './CriaFormularioAcompanhamento';
import ResponderPendencias from './ResponderPendencias';
// import TestandoBootstrap from './TestandoBootstrap.old';
import DownloadRelatorios from './DownloadRelatorios';
import DownloadRelatorioAcompanhamento from './DownloadRelatorioAcompanhamento';
import ConfiguracoesGerais from './ConfiguracoesGerais';
import InformarIndicadoresPlanilha from './InformarIndicadoresPlanilha';
import GerarRelatorios from './GerarRelatorios';
import AcompanharPendencias from './AcompanharPendencias';
import AjustarIndicadores from './AjustarIndicadores';

function Rotas() {

    console.log('### Iniciando ROTAS ###');

    return (
        <Routes>
            {/*------ Rodas publicas ------*/}

            <Route path='/'
                element={<Home />} />

            <Route path='/graficos'
                element={<Graficos />} />

            <Route path='/informativos'
                element={<TelaInformativa
                    cabecalho=''
                    mensagem=''
                    pathRedirect=''
                    buttonMessage=''
                    urlExterna={false} />}
            />

            {/*------ Rodas privadas ------*/}

            <Route path='/indicador/informar-por-planilha'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['informarIndicadores']}>
                        <InformarIndicadoresPlanilha />
                    </PrivateRoute>}
            />

            <Route path='/indicador/ajustar'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['ajustarIndicadores']}>
                        <AjustarIndicadores />
                    </PrivateRoute>}
            />

            <Route path='/relatorio-acompanhamento/criar'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['criaRelatorioAcompanhamento']}>
                        <CriaFormularioAcompanhamento />
                    </PrivateRoute>}
            />

            <Route path='/relatorio-acompanhamento/pendencias/responder'
                element={<PrivateRoute acceptedRoles={permissoesRotas['responderPendencia']}>
                    <ResponderPendencias />
                </PrivateRoute>}
            />

            <Route path='/relatorio-acompanhamento/pendencias/acompanhar'
                element={<PrivateRoute acceptedRoles={permissoesRotas['acompanharPendencias']}>
                    <AcompanharPendencias />
                </PrivateRoute>}
            />

            <Route path='/download/relatorios'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['downloadRelatorios']}>
                        <DownloadRelatorios />
                    </PrivateRoute>}
            />

            <Route path='/download/relatorio-acompanhamento'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['downloadRelatorioAcompanhamento']}>
                        <DownloadRelatorioAcompanhamento />
                    </PrivateRoute>}
            />

            <Route path='/testes'
                element={<PrivateRoute acceptedRoles={permissoesRotas['testes']}>
                    {/* <TestandoBootstrap /> */}
                </PrivateRoute>}
            />

            <Route path='/admin/configuracoes-gerais'
                element={<PrivateRoute acceptedRoles={permissoesRotas['configuracoesGerais']}>
                    <ConfiguracoesGerais />
                </PrivateRoute>}
            />

            <Route path='/admin/gerar-relatorios'
                element={<PrivateRoute acceptedRoles={permissoesRotas['gerarRelatorios']}>
                    <GerarRelatorios />
                </PrivateRoute>}
            />

        </Routes>
    );
}

export default Rotas;
